<template>
  <VDialogV3
    id="supply-offer-tariff-card"
    width="400px"
    :entity="localTariff"
    :loading="false"
    @submit="submit"
  >
    <section>
      <VInputNumberRus
        v-model="localTariff.qty.start"
        label="Кол-во, от"
        :unit="supplyOffer.unit"
        required
      />

      <VFormItem ratio="2/1">
        <VInputNumberRusV2
          v-model="localTariff.price"
          label="Цена"
          helper-text-position="right"
          :type="Price"
          :unit="`${supplyOffer?.unit} / ${localTariff.currency?.toString({ format: 'symbol' })}`"
          required
        />

        <VSelectV2
          v-model="localTariff.currency"
          label="Валюта"
          :data="CurrenciesService.currencies"
          :disabled="localTariff.isExisting"
          hide-clear-btn
          required
        />
      </VFormItem>

      <p
        v-if="tariff?.isFromOrder === true"
        class="description"
      >
        Цена взята из заказа №{{ tariff.orderId }}. Исправленная цена сохранится новым тарифом без ссылки на заказ
      </p>

      <VDateInput
        v-model="localTariff.validityPeriod.start"
        label="Действует с"
        layout="vertical"
        placeholder="Дата"
        required
      />

      <hr>

      <VDateInput
        v-model="localTariff.validityPeriod.end"
        label="Действует по"
        layout="vertical"
        placeholder="Без срока"
      />
    </section>
  </VDialogV3>
</template>

<script lang="ts">
import SupplyOffer       from '@/domains/SupplyOffers/SupplyOffer';
import SupplyOfferTariff from '@/domains/SupplyOffers/SupplyOfferTariff';
import Price             from '@/core/types/Price';
import CurrenciesService from '@/domains/Currencies/CurrenciesService';

export default defineComponent({
  name: 'SupplyOfferTariffCard',

  props: {
    /** Родительское разрешение — нужно для валюты и единицы измерения */
    supplyOffer: {
      type:     Object as PropType<SupplyOffer>,
      required: true,
    },

    /** Тариф для редактирования. null — режим создания */
    tariff: {
      type:    Object as PropType<SupplyOfferTariff>,
      default: null,
    },
  },

  emits: [SupplyOffer.Events.Updated],

  setup() {
    return {
      Price,
      CurrenciesService,
    };
  },

  data() {
    let localTariff;

    if (this.tariff) {
      localTariff = this.$core.utils.cloneDeep(this.tariff);
    }
    else {
      localTariff = SupplyOfferTariff.getEmpty(this.supplyOffer);
    }

    return {
      localTariff,
    };
  },

  methods: {
    submit(): void {
      const validityPeriod = this.localTariff.validityPeriod;

      if (validityPeriod.end?.isBefore(validityPeriod.start!) === true) {
        this.$core.showNotification.error('Дата окончания действия цены раньше даты начала');
      }
      else {
        if (this.tariff?.isFromOrder === true && this.localTariff.isSameTariff(this.tariff) === false) {
          this.localTariff.detachFromOrder();
        }

        this.$emit(SupplyOffer.Events.Updated, this.localTariff);
        this.$core.dialogs.SupplyOfferTariffCard.resolve();
      }
    },
  },
});
</script>
